module.exports = JSON.parse('{"languageSwitcher":{"label":"Dil"},"close":"Bağla","pageTitle":"Yeni il 2027 — Heç nə artıq! | NL International"}')